/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'

export default {
  SET_TEST_RESULT(state, payload){
    state.testResults = payload.sort(function(a,b) {return a.online_test.create_time < b.online_test.create_time ? -1 : a.online_test.create_time < b.online_test.create_time ? 1 : 0 })
  },
  SET_REPORT_RESULT(state, payload){
    state.reports = payload.sort(function(a,b) {return a.submit.create_time < b.submit.create_time ? -1 : a.submit.create_time < b.submit.create_time ? 1 : 0 })
  },
  SET_INSIGHT_VECTOR(state, payload){
    state.insightVector.push(payload)
  },
  SET_ATTEND(state, payload){
    state.attends = payload.sort(function(a,b) {return a.attend.day_time < b.attend.day_time ? -1 : a.attend.day_time < b.attend.day_time ? 1 : 0 })
  },
  UPDATE_SUBMIT_INSIGHT_VECTOR(state, payload){
    var obj = {'submit_id':payload.submit_id, 'submit_member_id':payload.submit_member_id, 'score':payload.score, 'submit_title':payload.submit_title}
    Vue.set(state.insightVector[payload.index], [payload.fildName], obj)
    state.insightVector[payload.index].submit.push(payload.score)
    // Vue.set(state.insightVector[payload.index], [payload.fildName], payload.score)

  },
  UPDATE_TEST_INSIGHT_VECTOR(state, payload){
    // console.log( state.insightVector[payload.index])
    // Vue.set(state.insightVector[payload.index], 'test_id', payload.test_id)
    // Vue.set(state.insightVector[payload.index], 'test_member_id', payload.test_member_id)
    // var obj = {'test_id':payload.test_id, 'test_member_id':payload.test_member_id, 'score':payload.score, 'test_title':payload.test_title}
    Vue.set(state.insightVector[payload.index], [payload.fildName], payload.score)

    // state.insightVector[payload.index].test.push(payload.score)
  },
  // SET_ATTEND_VECTOR(state, payload){
  //   state.attendVector.push(payload)
  // },
  UPDATE_ATTEND_VECTOR(state, payload){
    Vue.set(state.insightVector[payload.index], [payload.fildName], payload.attendVal)
    // console.lostate.attendVector)
  },
  UNREGISTER(state){
    state.testResults = null
    state.reports = null
    state.insightVector = []
    state.attends = null
    state.attendVector = []
  },
  SET_PROJECT_INFO_LIST(state, payload){
    state.projectsInfo = payload
  },
  GET_JOIN_TYPE(state, payload){
    state.userType = payload
  },
  GET_JOIN_MONTH(state, month){
    state.userMonth = month
  }
  // SET_USERS(state, users) {
  //   state.users = users
  // },
  // REMOVE_RECORD(state, itemId) {
  //     const userIndex = state.users.findIndex((u) => u.id == itemId)
  //     state.users.splice(userIndex, 1)
  // },
}
